/**
 * Opens the in-app help manual at the given anchor section.
 * The manual opens in a new tab so the user's current app state is preserved.
 *
 * @param {string} [anchor=''] - Section anchor without leading '#' (e.g. 'editor', 'dashboard', 'wizard')
 */
const openHelp = (anchor = '') => {
  const url = '/help/index.html' + (anchor ? '#' + anchor : '');
  window.open(url, '_blank', 'noopener,noreferrer');
};

export default openHelp;
